import { AppRegistry } from 'react-native';
import App from './App';
import appJson from './app.json';

const appName = appJson.name || 'EduWriteStudentApp';

// Register the app with React Native Web
AppRegistry.registerComponent(appName, () => App);

// Run the application into #app-root
AppRegistry.runApplication(appName, {
  initialProps: {},
  rootTag: document.getElementById('app-root'),
});
